const NotFoundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
      viewBox="0 0 100 100"
    >
      <circle cx="50" cy="50" r="50" fill="#202553"></circle>
      <g clipPath="url(#clip0)">
        <path
          fill="#fff"
          d="M31.41 34.108h37.193c0-1.035-.013-2.07 0-3.105.026-1.29.891-2.441 2.118-2.85 1.266-.41 2.699-.026 3.435 1.099.349.524.555 1.201.62 1.828.103.984.026 1.993.026 3.054h2.88c2.014 0 3.319 1.278 3.319 3.26v9.84c0 1.956-1.305 3.246-3.268 3.26h-2.88v20.448h2.751c.865 0 1.343.383 1.33 1.035-.013.64-.478 1.01-1.304 1.01H65.75c-.814 0-1.28-.384-1.28-1.023 0-.639.466-1.01 1.292-1.022h2.802V50.519H31.462v20.423h2.816c.8 0 1.278.396 1.265 1.035-.013.614-.478.997-1.24.997H22.358c-.814 0-1.278-.383-1.278-1.035.013-.64.477-1.01 1.291-1.01h2.802V50.48c-.813 0-1.64.013-2.466 0-.426-.012-.866 0-1.279-.09-1.42-.319-2.402-1.495-2.402-2.939a906.804 906.804 0 01-.013-10.262c.013-1.713 1.356-3.017 3.087-3.042 1.007-.013 2.014 0 3.112 0 0-1.1-.026-2.16 0-3.208.052-1.636 1.433-2.927 3.087-2.927 1.64 0 3.034 1.278 3.099 2.901.039.857.013 1.7.013 2.556v.64zm15.872 2.071c-.93.013-1.563.013-.93.013-.206 0 .207 0 0 0-3.59 0-7.193.013-10.783-.013-.478 0-.788.153-1.123.473a9395.84 9395.84 0 01-11.365 11.26c-.142.14-.284.293-.516.549h.8c3.552 0 7.103-.013 10.654.013.517 0 .879-.128 1.24-.499 3.771-3.757 8.252-8.064 12.023-11.796 1.175-.971.245-.205 0 0zm-9.53 12.23c.18.026.232.04.297.04 3.822 0 7.658.012 11.48-.014.258 0 .568-.178.75-.37 3.86-3.796 7.696-7.605 11.544-11.413.13-.128.233-.269.413-.473h-.684c-3.629 0-7.27.013-10.9-.013-.426 0-.71.128-1.007.422-3.796 3.77-7.593 7.528-11.39 11.285-.142.166-.284.32-.504.537zm39.671-12.217c-4.068 0-7.98-.013-11.894.013-.232 0-.503.204-.684.383-3.848 3.783-7.67 7.579-11.506 11.375-.13.127-.246.268-.452.485h.749c3.616 0 7.232 0 10.848.013.426 0 .71-.128 1.007-.422 3.81-3.783 7.632-7.566 11.454-11.349.13-.115.259-.255.478-.498zm-45.625 0H22.41c-.995 0-1.343.345-1.343 1.355V46.812l10.731-10.62zM68.086 48.46h9.492c1.02 0 1.356-.332 1.356-1.33v-8.818c0-.179-.026-.358-.038-.55-3.616 3.567-7.168 7.081-10.81 10.698zm-40.769 2.07v20.372h1.989V50.531h-1.989zm43.391 0v20.372h1.989V50.531h-1.989zM29.332 34.11v-.678c0-.805.012-1.61-.013-2.415a1.004 1.004 0 00-.995-.972c-.53-.012-1.02.384-1.033.933-.038 1.036-.013 2.07-.013 3.131h2.054zm43.352.025c0-1.112.052-2.236-.026-3.336-.039-.472-.478-.74-.994-.728-.517.013-.93.294-.956.78-.065 1.086-.026 2.185-.026 3.284h2.002z"
        ></path>
        <path stroke="#fff" d="M49.5 54L49.5 59"></path>
      </g>
      <path stroke="#fff" strokeWidth="1.5" d="M49.75 66L49.75 75"></path>
      <path stroke="#fff" strokeWidth="1.5" d="M49.75 83L49.75 100"></path>
      <path
        stroke="#fff"
        strokeWidth="1.5"
        d="M11.47 79.218L26.47 64.218"
      ></path>
      <path
        stroke="#fff"
        strokeWidth="1.5"
        d="M30.47 60.218L41.47 49.218"
      ></path>
      <path
        stroke="#fff"
        strokeWidth="1.5"
        d="M69.219 59.53L59.219 49.53"
      ></path>
      <path
        stroke="#fff"
        strokeWidth="1.5"
        d="M89.219 79.53L73.219 63.53"
      ></path>
      <circle cx="50" cy="50" r="47.5" stroke="#fff" strokeWidth="5"></circle>
      <defs>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0H62V45H0z"
            transform="translate(19 28)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotFoundIcon;
